import { LineChartOutlined } from "@ant-design/icons";
import { chartCore } from "./core/chart";
import { defineWidget } from "../widgetDefinition";
import { chartSlots } from "../Slots";
import { chartDuplicate } from "../Duplication/chart";
import { chartControlPanel } from "../ControlPanel/chart";
import type { ChartComponentSpec } from "../Processing/types";
import { ChartWidget } from "../WidgetComponents/ChartWidget";
import { ChartInfo } from "../Info/chart";
import { PlotConfigurator } from "../AddWidgetModal/PlotConfigurator";
import { BINDABLE_SECTIONS } from "../Processing/controllerBindings";

export const chartDefinition = defineWidget<ChartComponentSpec>({
  ...chartCore,
  type: "chart",
  dynamic: { bindableSections: BINDABLE_SECTIONS.chart },
  slots: chartSlots,
  duplicate: chartDuplicate,
  controlPanel: chartControlPanel,
  info: { Content: ChartInfo },
  schema: ["display", "widgetMutations", "series", "chart_builder_misc"],
  contractHash: "029leg6llel",
  needsData: true,

  template: {
    label: "Plot",
    description: "Trend performance over time or compare values",
    icon: <LineChartOutlined />,
  },

  defaultLayout: { w: 6, h: 12, minW: 3, minH: 2 },

  gridComponent: ({ id }) => <ChartWidget id={id} />,

  configurator: {
    modalTitle: "Plot Widget",
    wide: true,
    Component: PlotConfigurator as any,
  },
});
